<!--
 * @Descripttion: 单据信息
 * @version: 1
 * @Author: lk
 * @Date: 2019-08-22 10:32:04
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-27 15:58:43
 -->
<template>
  <div>
    <el-form class="orderInfo-form" label-suffix="： ">
      <el-form-item label="发货日期">
        {{ orderInfo.specifyDeliveryDate ? parseTime(orderInfo.specifyDeliveryDate, '{y}-{m}-{d}') : '' }}
      </el-form-item>
      <el-form-item label="单据编号">
        {{ orderInfo.bizId }}
      </el-form-item>
      <el-form-item label="业务类型">
        <!-- {{ orderInfo.used }} -->
        <span v-if="orderInfo.used !== '其他出库业务'">{{ orderInfo.used }}</span>
        <dict-tag v-else :options="dictObj.bizType" :value="orderInfo.qtType" />
      </el-form-item>
      <el-form-item label="申请部门">
        {{ orderInfo.applyOrgName }}
      </el-form-item>
      <el-form-item label="客户名称">
        {{ orderInfo.recipientInfoVo ? orderInfo.recipientInfoVo.customer : null }}
      </el-form-item>
      <el-form-item label="收件人区域">
        {{ area }}

      </el-form-item>
      <el-form-item label="收件人详细地址">
        {{ orderInfo.recipientInfoVo ? orderInfo.recipientInfoVo.customerAddress : null }}
      </el-form-item>
      <el-form-item label="收件人电话">
        {{ orderInfo.recipientInfoVo ? orderInfo.recipientInfoVo.customerTelephone : null }}
      </el-form-item>
      <el-form-item label="备注">
        {{ orderInfo.remark }}
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getOrderInfo } from '@/api/orderManage'
import { getDict } from '@/api/common'

export default {
  data() {
    return {
      orderInfo: {
        recipientInfoVo: {}
      },
      dictObj:{
        bizType:[]
      }
    }
  },
  computed: {
    area() {
      const { recipientInfoVo: { consigneeProvinceName = '', consigneeCityName = '', consigneeCountyName = '' } } = this.orderInfo
      return `${consigneeProvinceName}${consigneeCityName ? `/${consigneeCityName}` : ''}${consigneeCountyName ? `/${consigneeCountyName}` : ''}`
    }
  },

  methods: {
    // 获取单据信息
    getOrderInfo({ orderId }) {
      this.getDicts(['bizType'])
      this.orderId = orderId
      // 获取基础信息数据
      this.$emit('changeParentLoading', true)
      getOrderInfo(orderId).then(res => {
        this.orderInfo = res.data
      }).finally(() => {
        this.$emit('changeParentLoading', false)
      })
    },
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
        })
      })
    },

  }
}
</script>

<style scoped lang="scss">
.orderInfo-form {
  padding-left: 24px;
}

.orderInfo-form ::v-deep .el-form-item {
  margin-bottom: 0px !important;
}
</style>
